import React from 'react'

export default function Preloader() {
    return (
        <div className='preloader-container'>


            <div className='loader'>
                
            </div>

            <div className='preload-text'>
                We care! We Connect!
            </div>
        </div>
    )
}
